/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class GroupType {
    static Normal = 0;
    static Free = 1;
    static Restricted = 2;
    static Organization = 3;
}
